<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Color de impresión</span>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/color/byn.png" />
    <div class="flex flex-col">
      <span class="section_title">Blanco y negro</span>
      <span class="section_info">Se imprimirá con tóner negro en escala de grises, tus colores van a desaparecer.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/color/color.png" />
    <div class="flex flex-col">
      <span class="section_title">A full de color</span>
      <span class="section_info"
        >Pues eso, que te imprimimos tus colores con tintas de alta calidad en CMYK (cian, magenta, amarillo y
        negro).</span
      >
    </div>
  </div>
</div>
